module.exports = __webpack_public_path__ + "img/63_2.aea0d6ea.png";